import type React from "react";
import { Box, Image, Heading, VStack } from "@chakra-ui/react";
import FootballStadium from "../../assets/football-fans-stadium.png";
import Button from "../../components/Button";

type HeroSectionProps = {
  onClickCTA: () => void;
};

const HeroSection: React.FC<HeroSectionProps> = (props) => {
  return (
    <Box w='100%' position='relative' maxW='100%' alignSelf='center'>
      <VStack
        alignItems="center"
        // gap={6}
        gap={{
          base: '12px',
          xl: '28px',
        }}
        zIndex={1}
        position="absolute"
        left="0"
        right="0"
        top={{ base: "25%", sm: "25%" }}
      >
        <Heading
          fontStyle='italic'
          textAlign={'center'}
          color='white'
          width={{
            base: "95%",
            sm: "90%",
            md: "70%",
            lg: "80%",
          }}
          fontSize={{
            base: '16px',
            sm: '22px',
            md: '30px',
            lg: '36px',
            xl: '40px',
          }}
        >
          PREDICT THE UNPREDICTABLE
        </Heading>
        <Button
          onClick={props.onClickCTA}
          text='Create Your List'
          hoverBgColor='blue.800'
          fontSize={{ base: '14px', sm: '15px', md: '16px' }}
          px={{ base: '18px', md: '22px' }}
          py={{ base: '10px', md: '14px' }}
        />
      </VStack>
      <Image
        src={FootballStadium}
        borderRadius={["8px", "16px"]}
        width="100%"
        overflow="hidden"
        objectFit="cover"
        filter="brightness(40%)"
        maxH='420px'
        minH='160px'
        height={{
          base: '160px',
          sm: '34vh',
        }}
      />
    </Box>
  );
};

export default HeroSection;
